module.exports = __webpack_public_path__ + "static/media/6.be25e67d.jpg";